export const environment = {
    production: true,
    casUrl: 'https://cas.assas-universite.fr',
    casService: 'https%3A%2F%2Fapplications.u-paris2.fr%2Fassistance',
    // Base URL for API calls
    apiUrl: 'https://applications.u-paris2.fr/assistance/api/v1',
    env: 'production'
}